module.exports = __webpack_public_path__ + "img/trash.c76ddb57.svg";